var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { injectIntl } from "@irati/utils/lang";
import Select from "@irati/ui/src/FormItem/Select";
import TileShapes from "../enums/TileShapes";
var shapeOptions = [
    { value: TileShapes.square1x, label: "home.customisation.options.square1x1" },
    { value: TileShapes.square2x, label: "home.customisation.options.square2x2" },
    { value: TileShapes.rectangle2x1, label: "home.customisation.options.rectangle2x1" },
    { value: TileShapes.rectangle4x2, label: "home.customisation.options.rectangle4x2" }
];
var ShapePicker = /** @class */ (function (_super) {
    __extends(ShapePicker, _super);
    function ShapePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getOptions = function () {
            var _a = _this.props, formatMessage = _a.formatMessage, withText = _a.withText, withVideo = _a.withVideo;
            var options = shapeOptions.map(function (_a) {
                var value = _a.value, label = _a.label;
                return ({ value: value, label: formatMessage({ id: label }) });
            });
            if (withText) {
                return options.filter(function (_a) {
                    var value = _a.value;
                    return value === TileShapes.square2x;
                });
            }
            if (withVideo) {
                return options.filter(function (_a) {
                    var value = _a.value;
                    return value === TileShapes.rectangle2x1 || value === TileShapes.rectangle4x2;
                });
            }
            return options;
        };
        return _this;
    }
    ShapePicker.prototype.render = function () {
        var _a = this.props, selected = _a.selected, onChange = _a.onChange;
        var options = this.getOptions();
        return (React.createElement(Select, { name: "Shape selector", options: options, onChange: function (value) { return onChange(value); }, value: selected, isClearable: false }));
    };
    return ShapePicker;
}(PureComponent));
export default injectIntl(ShapePicker);
